import { FormBuilder, Validators, FormGroup } from '@angular/forms'
import { Component, OnInit, Inject } from '@angular/core'
import { Store } from '@ngrx/store'
import * as fromRoot from '@tv3/store/state'
import { SaveForm, Destroyable, createAddressForm } from '@tokeet-frontend/tv3-platform'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { AmplitudeService } from '@tv3/services/amplitude.service'
import { AddVendor, UpdateVendor, VendorResponse, VendorType } from '@tokeet-frontend/vendors'
import { InitialWhatsappDialogService } from '@tv3/containers/messages/initial-whatsapp-dialog/initial-whatsapp-dialog.service'
@Component({
  selector: 'app-vendor-dialog',
  templateUrl: './vendor-dialog.component.html',
  styleUrls: ['./vendor-dialog.component.scss'],
  host: { class: 'modal-content' },
})
export class VendorDialogComponent extends Destroyable implements OnInit {
  isEdit = false

  addressForm = createAddressForm(null, false)
  form = this.fb.group({
    type: [undefined, [Validators.required]],
    name: [undefined, [Validators.required]],
    email: [undefined, [Validators.required]],
    phone: [],
    whatsapp_number: [],
    address: this.addressForm,
  })

  types = Object.values(VendorType)

  constructor(
    private fb: FormBuilder,
    private amplitudeService: AmplitudeService,
    public dialogRef: MatDialogRef<VendorDialogComponent>,
    private initialWhatsappDialogService: InitialWhatsappDialogService,
    @Inject(MAT_DIALOG_DATA) public data: { vendor?: VendorResponse },
    private store: Store<fromRoot.State>
  ) {
    super()
  }

  ngOnInit() {
    this.isEdit = !!(this.data.vendor && this.data.vendor.pkey)
    if (this.isEdit) {
      this.form.patchValue({ ...this.data.vendor })
    }
  }

  onSendWhatsappMessage() {
    this.initialWhatsappDialogService.open({
      vendor: { ...this.data.vendor, ...this.form.getRawValue() },
    })
  }

  @SaveForm()
  onSave(form: FormGroup) {
    const payload = this.form.getRawValue()
    if (this.isEdit) {
      this.amplitudeService.logEvent(`update-vendor`)
      this.store.dispatch(UpdateVendor({ id: this.data.vendor.pkey, payload }))
    } else {
      this.amplitudeService.logEvent(`add-vendor`)
      this.store.dispatch(AddVendor({ payload }))
    }
    this.close()
  }

  close() {
    this.dialogRef.close()
  }
}
